import { reports } from "../reports";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { FormattedMessage } from "react-intl";

export const userAdvanceTabularReport = {
  label: <FormattedMessage id="REPORT_TABULARRPT_LBL" />,
  path: `${reports.path}/tabularReport/tabularAdvanceReport`,

  columns: (navigate, handleUserPopUp) => [
    {
      ID: 1,
      name: <FormattedMessage id="REPORT_USERNAME_TXT" />,
      fieldName: "ClassName",

      value: (row) => (
        <span
          style={{
            textDecoration: "underline",
            color: "#0051BC",
            cursor: "pointer",
          }}
          onClick={() => handleUserPopUp(row.UserId)}
        >
          {row.UserName}
        </span>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="REPORT_ASSGN_TXT" />,
      fieldName: "TotalAssigned",
      value: (row) => row.TotalAssigned,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 3,
      name: <FormattedMessage id="REPORT_COMPLETED_TXT" />,
      fieldName: "TotalCompleted",
      value: (row) => row.TotalCompleted,
      sort: true,
      type: tableColumnTypes.NUMBER,
    },
    {
      ID: 4,
      name: <FormattedMessage id="REPORT_INPROGESS_TXT" />,
      fieldName: "InProgress",
      value: (row) => row.InProgress,
      sort: true,
    },
    {
      ID: 5,
      name: <FormattedMessage id="REPORT_NOTYETSTRT_TXT" />,
      fieldName: "NotStartedYet",
      value: (row) => row.NotStartedYet,
      sort: true,
    },
    {
      ID: 6,
      name: <FormattedMessage id="REPORT_ARCHIVED_TEXT" />,
      fieldName: "Archived",
      value: (row) => row.Archived,
      sort: true,
    },
    {
      ID: 7,
      name: <FormattedMessage id="REPORT_AVGASSSCORE" />,
      fieldName: "AverageQuizScore",
      value: (row) => row.AverageQuizScore,
      sort: true,
    },
    {
      ID: 8,
      name: <FormattedMessage id="REPORT_COMPLETION_TXT" />,
      fieldName: "CompletedRatio",
      value: (row) => row.CompletedRatio,
      sort: true,
    },
  ],
};
